import { render, staticRenderFns } from "./AIChatInterface.vue?vue&type=template&id=0a18c722&scoped=true"
import script from "./AIChatInterface.vue?vue&type=script&lang=js"
export * from "./AIChatInterface.vue?vue&type=script&lang=js"
import style0 from "./AIChatInterface.vue?vue&type=style&index=0&id=0a18c722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18c722",
  null
  
)

export default component.exports